import React from 'react';
import './IntegrationOptions.css';
import kioskImage from '../assets/features/kiosk-raw.png';
import squareWorkflowImage from '../assets/features/square-workflow.jpg';

const IntegrationOptions = () => {
  return (
    <section id="integrations" className="integration">

      <div className="integration-intro container-narrow reveal">
        <span className="eyebrow">Built to fit your shop</span>
        <h2 className="integration-headline display">
          Whatever you run,<br />
          <em>Dangol fits.</em>
        </h2>
        <p className="integration-sub">
          Setup takes minutes. Plug into Square if you have it, or use our
          kiosk if you don&rsquo;t &mdash; either way, you&rsquo;re up and
          running fast.
        </p>
      </div>

      {/* Path 1 — Works with Square */}
      <div className="integration-spread integration-spread--left">
        <div className="integration-image reveal">
          <img
            src={squareWorkflowImage}
            alt="A barista using a tablet POS at a coffee shop counter, with a customer's hand resting nearby"
            className="integration-image-photo"
          />
        </div>
        <div className="integration-text reveal reveal-delay-1">
          <span className="integration-tag">If you&rsquo;re on Square</span>
          <h3 className="integration-title display">
            We work with everything you already have.
          </h3>
          <p className="integration-body">
            Dangol plugs into your existing Square hardware and ecosystem. It
            syncs with Square automatically &mdash; so you never have to manage
            two separate workflows. Your team rings up orders the way they
            always do.
          </p>
          <ul className="integration-points">
            <li>Direct integration with Square</li>
            <li>Customers scan a QR at checkout</li>
            <li>Earnings and visits sync automatically</li>
            <li><em>More POS integrations on the way</em></li>
          </ul>
        </div>
      </div>

      {/* Path 2 — Dangol kiosk */}
      <div className="integration-spread integration-spread--right">
        <div className="integration-text reveal">
          <span className="integration-tag">Not on Square? No problem.</span>
          <h3 className="integration-title display">
            Get a <em>Dangol</em> kiosk.
          </h3>
          <p className="integration-body">
            We send you a small kiosk for your counter. Customers scan in with
            the Dangol app and it handles everything automatically &mdash; no
            input needed from you. Don&rsquo;t get locked into your POS&rsquo;s
            loyalty program; with our kiosk, Dangol works with any setup.
          </p>
          <ul className="integration-points">
            <li>Plug-and-play, ready out of the box</li>
            <li>Customers scan in with their app &mdash; that&rsquo;s it</li>
            <li>Free for founding partners</li>
          </ul>
        </div>
        <div className="integration-image reveal reveal-delay-1">
          <img
            src={kioskImage}
            alt="A Dangol kiosk sitting on the wooden counter of an independent coffee shop"
            className="integration-image-photo integration-image-photo--kiosk"
          />
        </div>
      </div>

      <div className="integration-footer container-narrow reveal">
        <p className="integration-footer-text display-italic">
          Either way, you're building the same thing — a block full of regulars
          who keep coming back.
        </p>
      </div>

    </section>
  );
};

export default IntegrationOptions;
